import { useMutation } from "@tanstack/react-query";
import { useEffect, useRef } from "react";
import { withNamespaces } from "react-i18next";
import { toast } from "react-toastify";
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Spinner
} from "reactstrap";
import SupplierProductService from "src/modules/3rd-party-management/apis/common/SupplierProductService";

const DeleteProductModal = ({ t, isOpen, toggle, onSuccess, product }) => {
    const cancelRef = useRef();

    const {
        mutate: deleteProductMutation,
        isLoading: deletionIsInProcess
    } = useMutation({
        mutationFn: async (productId) => {
            const service = SupplierProductService.getInstance();
            return await service.delete(productId);
        },
        onSuccess: () => {
            onSuccess();
            toggle();
            toast(t("Product deleted successfully."), {
                type: "success"
            });
        },
        onError: () => {
            toast(t("An error occurred while deleting product."), {
                type: "error"
            });
        }
    });

    useEffect(() => {
        if (isOpen) {
            setTimeout(() => {
                if(cancelRef.current) {
                    cancelRef.current.focus(); // Focus Cancel by default
                }
            }, 250);
        }
    }, [isOpen]);

    const productName = `${product?.name?.class} - ${t(product?.name?.name)}`;

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            role="dialog"
            aria-labelledby="deleteProductTitle"
            aria-describedby="deleteProductDesc"
            aria-modal="true"
        >
            <ModalHeader toggle={toggle} id="deleteProductTitle">
                {t('Confirm Deletion')}
            </ModalHeader>

            <ModalBody id="deleteProductDesc">
                {t('Are you sure you want to delete the product')}:{' '}
                <strong>{productName}</strong>?
            </ModalBody>

            <ModalFooter>
                <Button
                    innerRef={cancelRef}
                    color="secondary"
                    onClick={toggle}
                    aria-label="Cancel deletion"
                >
                    {t('Cancel')}
                </Button>
                <Button
                    color="danger"
                    onClick={() => {
                        deleteProductMutation(product.id)
                    }}
                    aria-label={`${t('Delete Product')} ${productName}`}
                    disabled={deletionIsInProcess}
                >
                    {deletionIsInProcess && (
                        <Spinner 
                            size='sm'
                            color='white'
                            className="me-1"
                        />
                    )}
                    {t('Delete')}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default withNamespaces()(
    DeleteProductModal
);
